import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import CompanyInfo from "@/pages/CompanyInfo";
import Diagnostic from "@/pages/Diagnostic";
import Processing from "@/pages/Processing";
import Results from "@/pages/Results";
import { DiagnosticProvider } from "@/context/DiagnosticContext";

// Admin (Painel HUB)
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import AdminLayout from "@/components/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminDiagnosticsList from "@/pages/admin/AdminDiagnosticsList";
import AdminDiagnosticDetail from "@/pages/admin/AdminDiagnosticDetail";
import AdminExports from "@/pages/admin/AdminExports";
import AdminSettings from "@/pages/admin/AdminSettings";

function PublicApp({ children }) {
  return (
    <DiagnosticProvider>
      <Layout>{children}</Layout>
    </DiagnosticProvider>
  );
}

function AdminApp({ children }) {
  return <AdminLayout>{children}</AdminLayout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            {/* Public flow */}
            <Route path="/" element={<PublicApp><Landing /></PublicApp>} />
            <Route path="/dados" element={<PublicApp><CompanyInfo /></PublicApp>} />
            <Route path="/diagnostico" element={<PublicApp><Diagnostic /></PublicApp>} />
            <Route path="/processando" element={<PublicApp><Processing /></PublicApp>} />
            <Route path="/resultado/:id" element={<PublicApp><Results /></PublicApp>} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminApp><AdminDashboard /></AdminApp>} />
            <Route path="/admin/diagnosticos" element={<AdminApp><AdminDiagnosticsList /></AdminApp>} />
            <Route path="/admin/diagnosticos/:id" element={<AdminApp><AdminDiagnosticDetail /></AdminApp>} />
            <Route path="/admin/exportacoes" element={<AdminApp><AdminExports /></AdminApp>} />
            <Route path="/admin/configuracoes" element={<AdminApp><AdminSettings /></AdminApp>} />
          </Routes>
        </AdminAuthProvider>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
